<template>
  <div id="app">
    <notifications
      position="top center"
      class="app-notification"
      :duration="5000"
      :width="400"
    />
    <transition name="fade" mode="out-in" v-if="isLoading">
      <app-loading
        class="fullscreen"
        v-if="isLoading"
        :is-loading="isLoading"
        :spinner-color="'#1474a4'"
      />
    </transition>

    <template v-else>
      <app-header class="app-header" v-if="!correntRoutes"/>
      <main class="main">
        <router-view />
      </main>

      <generic-custom-code
        v-if="!correntRoutes"
        :generic-script="genericScript"
        :generic-html="genericHtml"
      />
      <app-footer class="app-footer" v-if="!correntRoutes"/>
    </template>
  </div>
</template>

<script>
  import AppHeader from 'components/AppHeader'
  import AppFooter from 'components/AppFooter'
  import GenericCustomCode from 'components/GenericCustomCode'
  import { mapGetters, mapState } from 'vuex'
  import { loadLolization } from './utilities/i18n'

  export default {
    components: {
      AppHeader,
      AppFooter,
      GenericCustomCode
    },

    data () {
      return {
        isLoading: true
      }
    },

    computed: {
      ...mapGetters('account', ['isAuthenticated']),
      ...mapState('culture', ['genericHtml', 'genericScript']),
      correntRoutes () {
        return this.$route.name === 'udi-return'
      }
    },

    watch: {
      'isAuthenticated': {
        handler (newVal) {
          if (newVal) {
            this.$store.dispatch('account/fetchPaymentActivity')
            setInterval(() => this.$store.dispatch('account/fetchPaymentActivity'), 1000 * 30)
          }
        },
        immediate: true
      }
    },

    async created () {
      try {
        await loadLolization()
        this.$store.dispatch('culture/fetchCultureConfig')
        if (this.isAuthenticated) {
          this.$store.dispatch('account/loadUserInfoFromLocalStorage')
        }
      } catch (e) {
      } finally {
        this.isLoading = false
      }
    }
  }
</script>

<style lang="scss">
  .main {
    padding-top: .48rem;
  }
</style>
